import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`


`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const SectionHeader = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
